import { styled } from "@mui/material/styles";
import { Button, ErrorIcon } from "@UI";
import React from "react";
import { useTranslation } from "react-i18next";
import { interruptionKey } from "../utils/cardInterruption";
import { HookCard, SettledLine, useCardFocus } from "./HookCard";
const Items = styled("ul")({
    margin: 0,
    padding: 0,
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    gap: "var(--j-sp-1)",
    fontSize: "var(--j-fs-sm)",
    lineHeight: "var(--j-lh-sm)",
    "& > li": {
        display: "flex",
        justifyContent: "space-between",
        gap: "var(--j-sp-2)"
    },
    "& > li + li": {
        paddingTop: "var(--j-sp-1)",
        borderTop: "1px solid var(--j-line-soft)"
    },
    "& .item-label": {
        fontWeight: 500,
        minWidth: 0,
        overflowWrap: "anywhere"
    },
    "& .item-detail": {
        color: "var(--j-ink-2)",
        textAlign: "right",
        overflowWrap: "anywhere"
    }
});
export function ToolConfirmationCard({ request, decision, responding, interrupted, onRespond }) {
    const { t } = useTranslation();
    const hasSettled = decision !== undefined;
    const isDestructive = request.category === "destructive";
    const { cardRef, hadFocus } = useCardFocus();
    if (interrupted && !hasSettled) {
        return /*#__PURE__*/ React.createElement(SettledLine, {
            tone: interrupted === "skipped" ? "neutral" : "error",
            hadFocus: hadFocus
        }, t(interruptionKey(interrupted)));
    }
    if (hasSettled) {
        return /*#__PURE__*/ React.createElement(SettledLine, {
            tone: decision ? "ok" : "neutral",
            hadFocus: hadFocus
        }, decision ? request.acceptedLabel : request.rejectedLabel);
    }
    return /*#__PURE__*/ React.createElement(HookCard, {
        ref: cardRef,
        "data-tone": isDestructive ? "destructive" : undefined,
        "aria-busy": responding || undefined
    }, /*#__PURE__*/ React.createElement("div", {
        className: "hook-head"
    }, isDestructive && /*#__PURE__*/ React.createElement(ErrorIcon, {
        size: 16,
        color: "var(--j-err)",
        style: {
            flexShrink: 0,
            marginTop: 1
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "hook-text"
    }, /*#__PURE__*/ React.createElement("h4", null, request.title), /*#__PURE__*/ React.createElement("p", {
        className: "hook-desc"
    }, request.message))), request.items.length > 0 && /*#__PURE__*/ React.createElement(Items, null, request.items.map((item)=>/*#__PURE__*/ React.createElement("li", {
            key: item.id
        }, /*#__PURE__*/ React.createElement("span", {
            className: "item-label"
        }, item.label), item.detail && /*#__PURE__*/ React.createElement("span", {
            className: "item-detail"
        }, item.detail)))), /*#__PURE__*/ React.createElement("div", {
        className: "hook-actions"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "outline",
        disabled: responding,
        onClick: ()=>onRespond?.(request.toolCallId, false)
    }, request.cancelLabel), /*#__PURE__*/ React.createElement(Button, {
        variant: isDestructive ? "danger" : "primary",
        loading: responding,
        onClick: ()=>onRespond?.(request.toolCallId, true)
    }, request.confirmLabel)));
}
